import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {hideInAppVideos, setExceptionHandler} from '@app/store/actions';
import { basicService } from '@app/services';
import {Breadcrumbs, InAppVideos, ListPageBar, Navbar, SidebarComponent} from '@app/components';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment/min/locales';
import { PasslySnackbar } from '@app/componentsV2';
import { ISnackbarState } from '@app/models';
import { localStore } from '@app/helpers';
import { KASEYA_ONE_TOKEN } from '@app/constants';
import videoData from '@app/components/Navbar/components/vimeoVideoData.json';

interface IMainProps {
    children: JSX.Element;
}

const TAG_COLORS = {
    'Getting Started': 'green',
    'Directory Manager': 'ocean-blue',
    'Auth Manager': 'yellow',
    'SSO Manager': 'purple',
    'Policy Manager': 'red',
    'Report Manager': 'orange',
    'Password Manager': 'blue',
    'Integration Manager': 'grey'
};

const MainPage = (props: IMainProps) => {
    const [containerClasses, setContainerClasses] = useState<string>('');
    const [kaseyaOneToken, setKaseyaOneToken] = useState('');
    const filtersEnabled = useSelector((state: any) => state.listPageBar.sortingFiltersEnabled);
    const activeFilters = useSelector((state: any) => state.listPageBar.activeFilters);
    const isInAppVideosModalOpened = useSelector((state: any) => state.inAppVideos.isInAppVideosModalOpened);
    const snackbarData: ISnackbarState = useSelector((state: any) => state.snackbar.snackbar);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setExceptionHandler(true));
        setContainerClasses('container');
        moment.locale(basicService.getLocale());
    }, []);

    useEffect(() => {
        filtersEnabled
            ? activeFilters.length > 0
                ? setContainerClasses('container container--filtersEnabled container--activeFilters')
                : setContainerClasses('container container--filtersEnabled')
            : setContainerClasses('container');
    }, [filtersEnabled, activeFilters]);

    useEffect(() => {
        const token = localStore.getItem(KASEYA_ONE_TOKEN);

        if (token) {
            setKaseyaOneToken(`${token}`);
        }
    }, []);

    const handleCloseInAppVideos = () => {
        dispatch(hideInAppVideos());
    };

    const getVimeoMenuItems = (response: any) => {
        let videoResponse = response.data;
        const videoList: any[] = [];

        if (videoResponse) {
            videoResponse.forEach((video: any) => {
                const { name, embed, description, tags, created_time, link } = video;
                videoList.push({ name: name, iframe: embed.html, description: description, tags: tags, date: created_time, link: link });
            });

            return videoList;
        }
    };

    return (
        <>
            <div className='main'>
                <Navbar setKaseyaOneToken={setKaseyaOneToken} kaseyaOneToken={kaseyaOneToken} />
                {isInAppVideosModalOpened && (
                    <InAppVideos
                        onClose={handleCloseInAppVideos}
                        singleVideoViewSidebar={true}
                        dataVimeo={getVimeoMenuItems(videoData)}
                        tagColors={TAG_COLORS}
                    />
                )}
                <div className='main__container'>
                    <SidebarComponent />
                    <div className='main__content'>
                        <div className='navbar__bottom'>
                            <div className='navbar__content navbar__content--left'>
                                <Breadcrumbs />
                            </div>
                            <div className='navbar__content navbar__content--right'>
                                <ListPageBar />
                            </div>
                        </div>

                        <div className={containerClasses}>
                            {snackbarData.show && <PasslySnackbar />}
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MainPage;
